import React from "react";
import MyNavLink from "../MyNavLink";
import style from "./style.less";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { ChannelRemind } from "@/utils/UrlHelper";

const DepositHeader = (props) => {
  let history = useEnhancedHistory();
  const { langText } = React.useContext(LanguageContext)
  const homeClick = () => {
    if (typeof props.homeClick == "function") {
      props.homeClick();
      return;
    }
    history.replace(ChannelRemind("/home"));
  };
  return (
    <div class={style.outline} id="invite_header">
      <div class={style.header_content}>
        <div class={`${style.header_left}`}>
          <MyNavLink to="/home">
            <div style={{ display: "flex", alignItems: "center" }}>
              <div class={style.back_btn}>
                <span>{langText("btn_back")}</span>
              </div>
            </div>
          </MyNavLink>
        </div>
        <div class={`${style.header_center}`}>{langText("home_btn_deposit")}</div>
        <div class={`${style.header_right}`} onClick={homeClick}>
            <img src={require("@/assets/images/draw/img_shuoming.svg").default} style={{ width: "1.6rem" }} />
        </div>
      </div>
    </div>
  );
};

export default DepositHeader;
